'use strict';exports.__esModule = true;var _constants = require('../constants');






var buildVideoLinks = function buildVideoLinks() {var videoObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseUrl = (0, _constants.getAssetsBaseUrl)(_constants.cloudinaryContentTypes.VIDEO);
  var full = baseUrl + '/' + _constants.videoFullModifier + '/' + videoObject.id;
  var thumbnail = baseUrl + '/' + _constants.fullModifier + '/' + videoObject.id + '.jpg';

  return {
    full: full,
    thumbnail: thumbnail };

};exports.default =

buildVideoLinks;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/buildVideoLinks.js
// module id = 589
// module chunks = 0